import { useCallback, useEffect, useState } from "react";
import { UserPicker } from "@salesapp/ui";
import { dashboardDesignerApi } from "./api";

export function SharePanel({ orgId, dashboardId }: { orgId: string; dashboardId: string }) {
  const [members, setMembers] = useState<{ id: string; display_name: string }[]>([]);
  const [sharedWith, setSharedWith] = useState<string[]>([]);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setError("");
    try {
      const [allMembers, shares] = await Promise.all([
        dashboardDesignerApi.members(orgId),
        dashboardDesignerApi.listShares(orgId, dashboardId),
      ]);
      setMembers(allMembers);
      setSharedWith(shares.map(s => s.user_id));
    } catch (e) { setError((e as Error).message); }
  }, [orgId, dashboardId]);

  useEffect(() => { void load(); }, [load]);

  async function add(userId: string) {
    setError("");
    try {
      await dashboardDesignerApi.addShare(orgId, dashboardId, userId);
      setSharedWith(prev => [...prev, userId]);
    } catch (e) { setError((e as Error).message); }
  }

  async function remove(userId: string) {
    setError("");
    try {
      await dashboardDesignerApi.removeShare(orgId, dashboardId, userId);
      setSharedWith(prev => prev.filter(id => id !== userId));
    } catch (e) { setError((e as Error).message); }
  }

  return (
    <div className="dashboard-designer__shares">
      <h2>Share this dashboard</h2>
      <p className="dashboard-designer__shares-hint">
        Anyone added here can view this dashboard's charts, even without dashboard design rights.
        They never see the underlying CRM records. Send them the dashboard's link directly
        (CRM → Dashboards → View) rather than relying on them to find it in the sidebar.
      </p>
      {error ? <p role="alert">{error}</p> : null}
      <UserPicker options={members} selected={sharedWith} onAdd={id => void add(id)} onRemove={id => void remove(id)} />
    </div>
  );
}
